import { uiMutationTypes } from './mutation-types';

export const mutations = {
  [uiMutationTypes.ADD_RANGE_DATE] (state, dateRange) {
    state.dateRange = dateRange;
  },
  [uiMutationTypes.ADD_CHANNEL] (state, channel) {
    state.channel = channel;
  },
  [uiMutationTypes.ADD_TAB_NAME] (state, tabName) {
    state.tabName = tabName;
  },
  [uiMutationTypes.ADD_GROUP_LIST] (state, groupList) {
    state.groupList = groupList;
  },
};
